import { cn } from '@/lib/utils';

const Logo = ({ className = '' }) => {
  return (
    <div
      aria-hidden
      className={cn(
        `bg-primary [mask-image:url('/emovia-logo.svg?v=2')] mask-center mask-no-repeat mask-contain [-webkit-mask-image:url('/emovia-logo.svg?v=2')] [-webkit-mask-position:center] [-webkit-mask-repeat:no-repeat] [-webkit-mask-size:contain]`,
        className,
      )}
    />
  );
};

export default Logo;
